import { Link } from 'react-router-dom'

export default function ComingSoon() {
  return (
    <>
      <section className="coming-soon-area header-gap">
        <img src="./assets/home/coming-soon-back.webp" alt="comingsoon" className="img-responsive" />
        <div className="comingsoon-detail">
          <h1>We're Building Something Awesome—Stay Tuned</h1>
          <Link to={"/"} className="default-white">back to homepage</Link>
        </div>
      </section>
    </>
  )
}
